import React from 'react';
import { Group, Line, Text, Rect } from 'react-konva';

/**
 * DimensionLine Component
 * Renderiza uma linha de cota arquitetônica profissional:
 * - Linhas de chamada (extension lines)
 * - Linha de cota com ticks em 45 graus
 * - Texto centralizado com background branco
 */
export const DimensionLine = ({
  points,
  measurements,
  isSelected,
  scaleRatio = 1,
  unit = 'cm',
  onClick,
  onTap
}) => {
  if (!points || points.length < 4) return null;
  const [x1, y1, x2, y2] = points;

  const dx = x2 - x1;
  const dy = y2 - y1;
  const length = Math.sqrt(dx * dx + dy * dy);
  if (length < 2) return null;

  // Vetor unitário da linha e vetor normal perpendicular
  const ux = dx / length;
  const uy = dy / length;
  const nx = -uy;
  const ny = ux;

  // Valor da cota calculado ou baseado na escala
  const displayVal = measurements?.length 
    ? Math.round(measurements.length) 
    : Math.round(length * scaleRatio);

  const midX = (x1 + x2) / 2;
  const midY = (y1 + y2) / 2;

  // Ticks oblíquos a 45 graus nas extremidades
  const tickSize = 6;
  const tick1 = [
    x1 - (ux + nx) * tickSize,
    y1 - (uy + ny) * tickSize,
    x1 + (ux + nx) * tickSize,
    y1 + (uy + ny) * tickSize
  ];
  const tick2 = [
    x2 - (ux + nx) * tickSize,
    y2 - (uy + ny) * tickSize,
    x2 + (ux + nx) * tickSize,
    y2 + (uy + ny) * tickSize
  ];

  const strokeColor = isSelected ? '#ef4444' : '#2563eb';
  const textLabel = `${displayVal} ${unit}`;
  const textWidth = textLabel.length * 7.5;

  return (
    <Group onClick={onClick} onTap={onTap}>
      {/* Área de clique estendida */}
      <Line
        points={[x1, y1, x2, y2]}
        stroke="transparent"
        strokeWidth={20}
      />

      {/* Linha de cota principal */}
      <Line
        points={[x1, y1, x2, y2]}
        stroke={strokeColor}
        strokeWidth={1.5}
      />

      {/* Ticks nas extremidades */}
      <Line
        points={tick1}
        stroke={strokeColor}
        strokeWidth={2}
      />
      <Line
        points={tick2}
        stroke={strokeColor}
        strokeWidth={2}
      />

      {/* Caixa de fundo do texto para contraste */}
      <Rect
        x={midX - textWidth / 2 - 4}
        y={midY - 9}
        width={textWidth + 8}
        height={18}
        fill="white"
        stroke={isSelected ? '#ef4444' : '#93c5fd'}
        strokeWidth={1}
        cornerRadius={3}
      />

      {/* Texto da Medida */}
      <Text
        text={textLabel}
        x={midX - textWidth / 2}
        y={midY - 6}
        width={textWidth}
        align="center"
        fontSize={11}
        fontStyle="bold"
        fill={isSelected ? '#ef4444' : '#1e3a8a'}
        listening={false}
      />
    </Group>
  );
};

export default DimensionLine;
